import _asyncToGenerator from "/vercel/path0/website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path0/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _toArray from "/vercel/path0/website/node_modules/@babel/runtime/helpers/esm/toArray.js";
import _slicedToArray from "/vercel/path0/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/vercel/path0/website/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { atom, SECRET_INTERNAL_getScopeContext, useAtom, useSetAtom, SECRET_INTERNAL_registerPromiseAbort } from 'jotai';
export { useAtomValue, useSetAtom as useUpdateAtom } from 'jotai';
import { useContext, useCallback, useMemo } from 'react';
var RESET = Symbol();

function atomWithReset(initialValue) {
  var anAtom = atom(initialValue, function (get, set, update) {
    var nextValue = typeof update === "function" ? update(get(anAtom)) : update;
    set(anAtom, nextValue === RESET ? initialValue : nextValue);
  });
  return anAtom;
}

var WRITE_ATOM = "w";
var RESTORE_ATOMS = "h";

function useResetAtom(anAtom, scope) {
  var ScopeContext = SECRET_INTERNAL_getScopeContext(scope);
  var store = useContext(ScopeContext).s;
  var setAtom = useCallback(function () {
    return store[WRITE_ATOM](anAtom, RESET);
  }, [store, anAtom]);
  return setAtom;
}

function useReducerAtom(anAtom, reducer, scope) {
  var _useAtom = useAtom(anAtom, scope),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      state = _useAtom2[0],
      setState = _useAtom2[1];

  var dispatch = useCallback(function (action) {
    setState(function (prev) {
      return reducer(prev, action);
    });
  }, [setState, reducer]);
  return [state, dispatch];
}

function atomWithReducer(initialValue, reducer) {
  var anAtom = atom(initialValue, function (get, set, action) {
    return set(anAtom, reducer(get(anAtom), action));
  });
  return anAtom;
}

function atomFamily(initializeAtom, areEqual) {
  var shouldRemove = null;
  var atoms = /* @__PURE__ */new Map();

  var createAtom = function createAtom(param) {
    var item;

    if (areEqual === void 0) {
      item = atoms.get(param);
    } else {
      var _iterator = _createForOfIteratorHelper(atoms),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          if (areEqual(key, param)) {
            item = value;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    if (item !== void 0) {
      if (shouldRemove == null ? void 0 : shouldRemove(item[1], param)) {
        createAtom.remove(param);
      } else {
        return item[0];
      }
    }

    var newAtom = initializeAtom(param);
    atoms.set(param, [newAtom, Date.now()]);
    return newAtom;
  };

  createAtom.remove = function (param) {
    if (areEqual === void 0) {
      atoms.delete(param);
    } else {
      var _iterator2 = _createForOfIteratorHelper(atoms),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 1),
              key = _step2$value[0];

          if (areEqual(key, param)) {
            atoms.delete(key);
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  };

  createAtom.setShouldRemove = function (fn) {
    shouldRemove = fn;
    if (!shouldRemove) return;

    var _iterator3 = _createForOfIteratorHelper(atoms),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _step3$value = _slicedToArray(_step3.value, 2),
            key = _step3$value[0],
            value = _step3$value[1];

        if (shouldRemove(value[1], key)) {
          atoms.delete(key);
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  };

  return createAtom;
}

var getWeakCacheItem = function getWeakCacheItem(cache, deps) {
  do {
    var _deps = deps,
        _deps2 = _toArray(_deps),
        dep = _deps2[0],
        rest = _deps2.slice(1);

    var entry = cache.get(dep);

    if (!entry) {
      return;
    }

    if (!rest.length) {
      return entry[1];
    }

    cache = entry[0];
    deps = rest;
  } while (deps.length);
};

var setWeakCacheItem = function setWeakCacheItem(cache, deps, item) {
  do {
    var _deps3 = deps,
        _deps4 = _toArray(_deps3),
        dep = _deps4[0],
        rest = _deps4.slice(1);

    var entry = cache.get(dep);

    if (!entry) {
      entry = [new WeakMap()];
      cache.set(dep, entry);
    }

    if (!rest.length) {
      entry[1] = item;
      return;
    }

    cache = entry[0];
    deps = rest;
  } while (deps.length);
};

var createMemoizeAtom = function createMemoizeAtom() {
  var cache = /* @__PURE__ */new WeakMap();

  var memoizeAtom = function memoizeAtom(createAtom, deps) {
    var cachedAtom = getWeakCacheItem(cache, deps);

    if (cachedAtom) {
      return cachedAtom;
    }

    var createdAtom = createAtom();
    setWeakCacheItem(cache, deps, createdAtom);
    return createdAtom;
  };

  return memoizeAtom;
};

var memoizeAtom$4 = createMemoizeAtom();

function selectAtom(anAtom, selector) {
  var equalityFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Object.is;
  return memoizeAtom$4(function () {
    var refAtom = atom(function () {
      return {};
    });
    var derivedAtom = atom(function (get) {
      var slice = selector(get(anAtom));
      var ref = get(refAtom);

      if ("prev" in ref && equalityFn(ref.prev, slice)) {
        return ref.prev;
      }

      ref.prev = slice;
      return slice;
    });
    return derivedAtom;
  }, [anAtom, selector, equalityFn]);
}

function useAtomCallback(callback, scope) {
  var anAtom = useMemo(function () {
    return atom(null, function (get, set, _ref) {
      var _ref2 = _slicedToArray(_ref, 3),
          arg = _ref2[0],
          resolve = _ref2[1],
          reject = _ref2[2];

      try {
        resolve(callback(get, set, arg));
      } catch (e) {
        reject(e);
      }
    });
  }, [callback]);
  var invoke = useSetAtom(anAtom, scope);
  return useCallback(function (arg) {
    var isSync = true;
    var settled = {};
    var promise = new Promise(function (resolve, reject) {
      invoke([arg, function (v) {
        if (isSync) {
          settled = {
            v: v
          };
        } else {
          resolve(v);
        }
      }, function (e) {
        if (isSync) {
          settled = {
            e: e
          };
        } else {
          reject(e);
        }
      }]);
    });
    isSync = false;

    if ("e" in settled) {
      throw settled.e;
    }

    if ("v" in settled) {
      return settled.v;
    }

    return promise;
  }, [invoke]);
}

var memoizeAtom$3 = createMemoizeAtom();

var deepFreeze = function deepFreeze(obj) {
  if (typeof obj !== "object" || obj === null) return;
  Object.freeze(obj);
  var propNames = Object.getOwnPropertyNames(obj);

  var _iterator4 = _createForOfIteratorHelper(propNames),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var name = _step4.value;
      var value = obj[name];
      deepFreeze(value);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return obj;
};

function freezeAtom(anAtom) {
  return memoizeAtom$3(function () {
    var frozenAtom = atom(function (get) {
      return deepFreeze(get(anAtom));
    }, function (_get, set, arg) {
      return set(anAtom, arg);
    });
    return frozenAtom;
  }, [anAtom]);
}

function freezeAtomCreator(createAtom) {
  return function () {
    var anAtom = createAtom.apply(void 0, arguments);
    var origRead = anAtom.read;

    anAtom.read = function (get) {
      return deepFreeze(origRead(get));
    };

    return anAtom;
  };
}

var memoizeAtom$2 = createMemoizeAtom();

var isWritable = function isWritable(atom2) {
  return !!atom2.write;
};

var isFunction = function isFunction(x) {
  return typeof x === "function";
};

function splitAtom(arrAtom, keyExtractor) {
  return memoizeAtom$2(function () {
    var mappingCache = /* @__PURE__ */new WeakMap();

    var getMapping = function getMapping(arr, prev) {
      var mapping = mappingCache.get(arr);

      if (mapping) {
        return mapping;
      }

      var prevMapping = prev && mappingCache.get(prev);
      var atomList = [];
      var keyList = [];
      arr.forEach(function (item, index) {
        var key = keyExtractor ? keyExtractor(item) : index;
        keyList[index] = key;
        var cachedAtom = prevMapping && prevMapping.atomList[prevMapping.keyList.indexOf(key)];

        if (cachedAtom) {
          atomList[index] = cachedAtom;
          return;
        }

        var read2 = function read2(get) {
          var ref = get(refAtom);
          var currArr = get(arrAtom);
          var mapping2 = getMapping(currArr, ref.prev);
          var index2 = mapping2.keyList.indexOf(key);

          if (index2 < 0 || index2 >= currArr.length) {
            var prevItem = arr[getMapping(arr).keyList.indexOf(key)];

            if (prevItem) {
              return prevItem;
            }

            throw new Error("splitAtom: index out of bounds for read");
          }

          return currArr[index2];
        };

        var write2 = function write2(get, set, update) {
          var ref = get(refAtom);
          var arr2 = get(arrAtom);
          var mapping2 = getMapping(arr2, ref.prev);
          var index2 = mapping2.keyList.indexOf(key);

          if (index2 < 0 || index2 >= arr2.length) {
            throw new Error("splitAtom: index out of bounds for write");
          }

          var nextItem = isFunction(update) ? update(arr2[index2]) : update;
          set(arrAtom, [].concat(_toConsumableArray(arr2.slice(0, index2)), [nextItem], _toConsumableArray(arr2.slice(index2 + 1))));
        };

        atomList[index] = isWritable(arrAtom) ? atom(read2, write2) : atom(read2);
      });

      if (prevMapping && prevMapping.keyList.length === keyList.length && prevMapping.keyList.every(function (x, i) {
        return x === keyList[i];
      })) {
        mapping = prevMapping;
      } else {
        mapping = {
          atomList: atomList,
          keyList: keyList
        };
      }

      mappingCache.set(arr, mapping);
      return mapping;
    };

    var refAtom = atom(function () {
      return {};
    });

    var read = function read(get) {
      var ref = get(refAtom);
      var arr = get(arrAtom);
      var mapping = getMapping(arr, ref.prev);
      ref.prev = arr;
      return mapping.atomList;
    };

    var write = function write(get, set, action) {
      if ("read" in action) {
        console.warn("atomToRemove is deprecated. use action with type");
        action = {
          type: "remove",
          atom: action
        };
      }

      switch (action.type) {
        case "remove":
          {
            var index = get(splittedAtom).indexOf(action.atom);

            if (index >= 0) {
              var arr = get(arrAtom);
              set(arrAtom, [].concat(_toConsumableArray(arr.slice(0, index)), _toConsumableArray(arr.slice(index + 1))));
            }

            break;
          }

        case "insert":
          {
            var _index = action.before ? get(splittedAtom).indexOf(action.before) : get(splittedAtom).length;

            if (_index >= 0) {
              var _arr = get(arrAtom);

              set(arrAtom, [].concat(_toConsumableArray(_arr.slice(0, _index)), [action.value], _toConsumableArray(_arr.slice(_index))));
            }

            break;
          }

        case "move":
          {
            var index1 = get(splittedAtom).indexOf(action.atom);
            var index2 = action.before ? get(splittedAtom).indexOf(action.before) : get(splittedAtom).length;

            if (index1 >= 0 && index2 >= 0) {
              var _arr2 = get(arrAtom);

              if (index1 < index2) {
                set(arrAtom, [].concat(_toConsumableArray(_arr2.slice(0, index1)), _toConsumableArray(_arr2.slice(index1 + 1, index2)), [_arr2[index1]], _toConsumableArray(_arr2.slice(index2))));
              } else {
                set(arrAtom, [].concat(_toConsumableArray(_arr2.slice(0, index2)), [_arr2[index1]], _toConsumableArray(_arr2.slice(index2, index1)), _toConsumableArray(_arr2.slice(index1 + 1))));
              }
            }

            break;
          }
      }
    };

    var splittedAtom = isWritable(arrAtom) ? atom(read, write) : atom(read);
    return splittedAtom;
  }, keyExtractor ? [arrAtom, keyExtractor] : [arrAtom]);
}

function atomWithDefault(getDefault) {
  var EMPTY = Symbol();
  var overwrittenAtom = atom(EMPTY);
  var anAtom = atom(function (get) {
    var overwritten = get(overwrittenAtom);

    if (overwritten !== EMPTY) {
      return overwritten;
    }

    return getDefault(get);
  }, function (get, set, update) {
    if (update === RESET) {
      return set(overwrittenAtom, EMPTY);
    }

    return set(overwrittenAtom, typeof update === "function" ? update(get(anAtom)) : update);
  });
  return anAtom;
}

var memoizeAtom$1 = createMemoizeAtom();
var emptyArrayAtom = atom(function () {
  return [];
});

function waitForAll(atoms) {
  var createAtom = function createAtom() {
    var unwrappedAtoms = unwrapAtoms(atoms);
    var derivedAtom = atom(function (get) {
      var promises = [];
      var values = unwrappedAtoms.map(function (anAtom, index) {
        try {
          return get(anAtom);
        } catch (e) {
          if (e instanceof Promise) {
            promises[index] = e;
          } else {
            throw e;
          }
        }
      });

      if (promises.length) {
        throw Promise.all(promises);
      }

      return wrapResults(atoms, values);
    });
    return derivedAtom;
  };

  if (Array.isArray(atoms)) {
    if (atoms.length) {
      return memoizeAtom$1(createAtom, atoms);
    }

    return emptyArrayAtom;
  }

  return createAtom();
}

var unwrapAtoms = function unwrapAtoms(atoms) {
  return Array.isArray(atoms) ? atoms : Object.getOwnPropertyNames(atoms).map(function (key) {
    return atoms[key];
  });
};

var wrapResults = function wrapResults(atoms, results) {
  return Array.isArray(atoms) ? results : Object.getOwnPropertyNames(atoms).reduce(function (out, key, idx) {
    return _objectSpread(_objectSpread({}, out), {}, _defineProperty({}, key, results[idx]));
  }, {});
};

var NO_STORAGE_VALUE = Symbol();

function createJSONStorage(getStringStorage) {
  var lastStr;
  var lastValue;
  var storage = {
    getItem: function getItem(key) {
      var _a, _b;

      var parse = function parse(str2) {
        str2 = str2 || "";

        if (lastStr !== str2) {
          try {
            lastValue = JSON.parse(str2);
          } catch (_unused) {
            return NO_STORAGE_VALUE;
          }

          lastStr = str2;
        }

        return lastValue;
      };

      var str = (_b = (_a = getStringStorage()) == null ? void 0 : _a.getItem(key)) != null ? _b : null;

      if (str instanceof Promise) {
        return str.then(parse);
      }

      return parse(str);
    },
    setItem: function setItem(key, newValue) {
      var _a;

      return (_a = getStringStorage()) == null ? void 0 : _a.setItem(key, JSON.stringify(newValue));
    },
    removeItem: function removeItem(key) {
      var _a;

      return (_a = getStringStorage()) == null ? void 0 : _a.removeItem(key);
    }
  };

  if (typeof window !== "undefined" && typeof window.addEventListener === "function") {
    storage.subscribe = function (key, callback) {
      var storageEventCallback = function storageEventCallback(e) {
        if (e.key === key && e.newValue) {
          callback(JSON.parse(e.newValue));
        }
      };

      window.addEventListener("storage", storageEventCallback);
      return function () {
        window.removeEventListener("storage", storageEventCallback);
      };
    };
  }

  return storage;
}

var defaultStorage = createJSONStorage(function () {
  return typeof window !== "undefined" ? window.localStorage : void 0;
});

function atomWithStorage(key, initialValue) {
  var storage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultStorage;

  var getInitialValue = function getInitialValue() {
    var value = storage.getItem(key);

    if (value instanceof Promise) {
      return value.then(function (v) {
        return v === NO_STORAGE_VALUE ? initialValue : v;
      });
    }

    return value === NO_STORAGE_VALUE ? initialValue : value;
  };

  var baseAtom = atom(storage.delayInit ? initialValue : getInitialValue());

  baseAtom.onMount = function (setAtom) {
    var unsub;

    if (storage.subscribe) {
      unsub = storage.subscribe(key, setAtom);
      setAtom(getInitialValue());
    }

    if (storage.delayInit) {
      var value = getInitialValue();

      if (value instanceof Promise) {
        value.then(setAtom);
      } else {
        setAtom(value);
      }
    }

    return unsub;
  };

  var anAtom = atom(function (get) {
    return get(baseAtom);
  }, function (get, set, update) {
    var nextValue = typeof update === "function" ? update(get(baseAtom)) : update;

    if (nextValue === RESET) {
      set(baseAtom, initialValue);
      return storage.removeItem(key);
    }

    set(baseAtom, nextValue);
    return storage.setItem(key, nextValue);
  });
  return anAtom;
}

function atomWithHash(key, initialValue, options) {
  var serialize = (options == null ? void 0 : options.serialize) || JSON.stringify;

  var deserialize = (options == null ? void 0 : options.deserialize) || function (str) {
    try {
      return JSON.parse(str || "");
    } catch (_unused2) {
      return NO_STORAGE_VALUE;
    }
  };

  var _subscribe = (options == null ? void 0 : options.subscribe) || function (callback) {
    window.addEventListener("hashchange", callback);
    return function () {
      window.removeEventListener("hashchange", callback);
    };
  };

  var hashStorage = _objectSpread(_objectSpread({
    getItem: function getItem(key2) {
      if (typeof location === "undefined") {
        return NO_STORAGE_VALUE;
      }

      var searchParams = new URLSearchParams(location.hash.slice(1));
      var storedValue = searchParams.get(key2);
      return deserialize(storedValue);
    },
    setItem: function setItem(key2, newValue) {
      var searchParams = new URLSearchParams(location.hash.slice(1));
      searchParams.set(key2, serialize(newValue));

      if (options == null ? void 0 : options.replaceState) {
        history.replaceState(null, "", "#" + searchParams.toString());
      } else {
        location.hash = searchParams.toString();
      }
    },
    removeItem: function removeItem(key2) {
      var searchParams = new URLSearchParams(location.hash.slice(1));
      searchParams.delete(key2);

      if (options == null ? void 0 : options.replaceState) {
        history.replaceState(null, "", "#" + searchParams.toString());
      } else {
        location.hash = searchParams.toString();
      }
    }
  }, (options == null ? void 0 : options.delayInit) && {
    delayInit: true
  }), {}, {
    subscribe: function subscribe(key2, setValue) {
      var callback = function callback() {
        var searchParams = new URLSearchParams(location.hash.slice(1));
        var str = searchParams.get(key2);

        if (str !== null) {
          setValue(deserialize(str));
        } else {
          setValue(initialValue);
        }
      };

      return _subscribe(callback);
    }
  });

  return atomWithStorage(key, initialValue, hashStorage);
}

function atomWithObservable(createObservable, options) {
  var observableResultAtom = atom(function (get) {
    var _a;

    var observable = createObservable(get);
    var itself = (_a = observable[Symbol.observable]) == null ? void 0 : _a.call(observable);

    if (itself) {
      observable = itself;
    }

    var resolve;

    var makePending = function makePending() {
      return new Promise(function (r) {
        resolve = r;
      });
    };

    var initialResult = options && "initialValue" in options ? {
      d: typeof options.initialValue === "function" ? options.initialValue() : options.initialValue
    } : makePending();
    var setResult;
    var lastResult;

    var listener = function listener(result) {
      lastResult = result;
      resolve == null ? void 0 : resolve(result);
      setResult == null ? void 0 : setResult(result);
    };

    var subscription;
    var timer;

    var isNotMounted = function isNotMounted() {
      return !setResult;
    };

    var start = function start() {
      if (subscription) {
        clearTimeout(timer);
        subscription.unsubscribe();
      }

      subscription = observable.subscribe(function (d) {
        return listener({
          d: d
        });
      }, function (e) {
        return listener({
          e: e
        });
      });

      if (isNotMounted() && (options == null ? void 0 : options.unstable_timeout)) {
        timer = setTimeout(function () {
          if (subscription) {
            subscription.unsubscribe();
            subscription = void 0;
          }
        }, options.unstable_timeout);
      }
    };

    start();
    var resultAtom = atom(lastResult || initialResult);

    resultAtom.onMount = function (update) {
      setResult = update;

      if (lastResult) {
        update(lastResult);
      }

      if (subscription) {
        clearTimeout(timer);
      } else {
        start();
      }

      return function () {
        setResult = void 0;

        if (subscription) {
          subscription.unsubscribe();
          subscription = void 0;
        }
      };
    };

    return [resultAtom, observable, makePending, start, isNotMounted];
  });
  var observableAtom = atom(function (get) {
    var _get2 = get(observableResultAtom),
        _get3 = _slicedToArray(_get2, 1),
        resultAtom = _get3[0];

    var result = get(resultAtom);

    if ("e" in result) {
      throw result.e;
    }

    return result.d;
  }, function (get, set, data) {
    var _get4 = get(observableResultAtom),
        _get5 = _slicedToArray(_get4, 5),
        resultAtom = _get5[0],
        observable = _get5[1],
        makePending = _get5[2],
        start = _get5[3],
        isNotMounted = _get5[4];

    if ("next" in observable) {
      if (isNotMounted()) {
        set(resultAtom, makePending());
        start();
      }

      observable.next(data);
    } else {
      throw new Error("observable is not subject");
    }
  });
  return observableAtom;
}

var hydratedMap = /* @__PURE__ */new WeakMap();

function useHydrateAtoms(values, scope) {
  var ScopeContext = SECRET_INTERNAL_getScopeContext(scope);
  var scopeContainer = useContext(ScopeContext);
  var store = scopeContainer.s;
  var hydratedSet = getHydratedSet(scopeContainer);
  var tuplesToRestore = [];

  var _iterator5 = _createForOfIteratorHelper(values),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var tuple = _step5.value;
      var _atom = tuple[0];

      if (!hydratedSet.has(_atom)) {
        hydratedSet.add(_atom);
        tuplesToRestore.push(tuple);
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  if (tuplesToRestore.length) {
    store[RESTORE_ATOMS](tuplesToRestore);
  }
}

function getHydratedSet(scopeContainer) {
  var hydratedSet = hydratedMap.get(scopeContainer);

  if (!hydratedSet) {
    hydratedSet = /* @__PURE__ */new WeakSet();
    hydratedMap.set(scopeContainer, hydratedSet);
  }

  return hydratedSet;
}

var memoizeAtom = createMemoizeAtom();
var LOADING = {
  state: "loading"
};

function loadable(anAtom) {
  return memoizeAtom(function () {
    var loadableAtomCache = /* @__PURE__ */new WeakMap();
    var catchAtom = atom(function (get) {
      var promise;

      try {
        var data = get(anAtom);
        var loadableAtom2 = atom({
          state: "hasData",
          data: data
        });
        return loadableAtom2;
      } catch (error) {
        if (error instanceof Promise) {
          promise = error;
        } else {
          var _loadableAtom = atom({
            state: "hasError",
            error: error
          });

          return _loadableAtom;
        }
      }

      var cached = loadableAtomCache.get(promise);

      if (cached) {
        return cached;
      }

      var loadableAtom = atom(LOADING, /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(get2, set) {
          var _data;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return get2(anAtom, {
                    unstable_promise: true
                  });

                case 3:
                  _data = _context.sent;
                  set(loadableAtom, {
                    state: "hasData",
                    data: _data
                  });
                  _context.next = 10;
                  break;

                case 7:
                  _context.prev = 7;
                  _context.t0 = _context["catch"](0);
                  set(loadableAtom, {
                    state: "hasError",
                    error: _context.t0
                  });

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 7]]);
        }));

        return function (_x, _x2) {
          return _ref3.apply(this, arguments);
        };
      }());

      loadableAtom.onMount = function (init) {
        init();
      };

      loadableAtomCache.set(promise, loadableAtom);
      return loadableAtom;
    });
    var derivedAtom = atom(function (get) {
      var loadableAtom = get(catchAtom);
      return get(loadableAtom);
    });
    return derivedAtom;
  }, [anAtom]);
}

function abortableAtom(read, write) {
  return atom(function (get) {
    var controller = new AbortController();
    var promise = read(get, {
      signal: controller.signal
    });

    if (promise instanceof Promise) {
      SECRET_INTERNAL_registerPromiseAbort(promise, function () {
        return controller.abort();
      });
    }

    return promise;
  }, write);
}

export { RESET, abortableAtom, atomFamily, atomWithDefault, atomWithHash, atomWithObservable, atomWithReducer, atomWithReset, atomWithStorage, createJSONStorage, freezeAtom, freezeAtomCreator, loadable, selectAtom, splitAtom, NO_STORAGE_VALUE as unstable_NO_STORAGE_VALUE, useAtomCallback, useHydrateAtoms, useReducerAtom, useResetAtom, waitForAll };